/* eslint-disable */
// FIXME: enable eslint
import Vue from "vue";
import VueCookies from "vue-cookies";
import ModalAlert from "@/components/patterns/ModalAlert"; // eslint-disable-line import/no-extraneous-dependencies
import userLogout from "~/helpers/userLogout"; // eslint-disable-line import/no-extraneous-dependencies
import Order from "../../clients/order"; // eslint-disable-line import/no-extraneous-dependencies

const state = {
  orders: {},
  ordersLoaded: false,
  order: { id: "" },
  registrations: [],
  selectedLabs: {},
  selectedLegs: [],
  activeRegistrationIndex: null,
  legSelectRegistrationIndex: -1,
  bundleItemIndex: null,
  selectedLeg: {},
  firstEmptySession: null,
  voidLabsChecked: false,
  generalErrorMessage: "",
  labSavedMessage: "",
};

const getters = {
  sessions: moduleState => () => {
    const activeRegistration = moduleState.registrations[moduleState.activeRegistrationIndex];
    return activeRegistration && activeRegistration.linked_event.sessions
      ? activeRegistration.linked_event.sessions
      : [];
  },
  activeRegistration: moduleState => () => {
    return moduleState.registrations[moduleState.activeRegistrationIndex];
  },
  activeRegistrationIndex: ({ activeRegistrationIndex }) => activeRegistrationIndex,
  legSelectRegistration: moduleState => () => {
    return moduleState.registrations[moduleState.legSelectRegistrationIndex];
  },
  legSelectRegistrationIndex: ({ legSelectRegistrationIndex }) => legSelectRegistrationIndex,
  bundleItem: (moduleState, getters) => {
    const registration = getters.legSelectRegistration();
    return registration ? getters.legSelectRegistration().linked_event.bundle_items[moduleState.bundleItemIndex] : {};
  },
  selectedLeg: ({ selectedLeg }) => selectedLeg,
  orders: ({ orders }) => orders,
  order: ({ order }) => order,
  labSavedMessage: ({ labSavedMessage }) => labSavedMessage,
  generalErrorMessage: ({ generalErrorMessage }) => generalErrorMessage,
  selectedLabs: moduleState => moduleState.selectedLabs,
  firstEmptySession: moduleState => moduleState.firstEmptySession,
  voidLabsChecked: moduleState => moduleState.voidLabsChecked,
  registrations: moduleState => moduleState.registrations,
  registrationsId: moduleState => {
    return moduleState.registrations.map(item => item.id);
  },
  hasBundledItems: moduleState => () => {
    return moduleState.registrations.filter(item => {
      item.linked_event.bundle_items && item.linked_event.bundle_items.length;
    });
  },
  waitingLegSelection: moduleState => () => {
    return moduleState.registrations.filter(item => {
      return (
        item.linked_event.bundle_items &&
        item.linked_event.bundle_items.length &&
        item.bundle_children &&
        !item.bundle_children.length &&
        moduleState.legSelectRegistrationIndex !== null
      );
    });
  },
  ordersLoaded: moduleState => moduleState.ordersLoaded,
};

const actions = {
  async fetchOrders({ commit, rootState }) {
    try {
      const orders = await Order.getOrders(rootState.config);
      commit("setOrdersLoaded");
      commit("setOrders", orders.results);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      commit("setOrdersLoaded");
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async fetchOrder({ commit, rootState, getters }, orderId) {
    try {
      const order = await Order.getOrder(rootState.config, orderId);
      commit("setOrder", order);
      commit("setRegistrations", order.registrations);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async fetchCartOrder({ commit, rootState }, orderId) {
    try {
      const order = await Order.getCart(rootState.config);
      commit("setOrder", order);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      // pass
    }
  },
  async storeOrderConfirmedData({ commit, state, rootState, getters }, status) {
    if (getters.waitingLegSelection().length) {
      commit("setOrderState", rootState.config.states.LegSelection);
      return;
    }
    try {
      const orderState = await Order.setOrderState(
        rootState.config,
        state.order,
        rootState.config.api.states.data_confirmation
      );
      commit("setOrderState", orderState.state);
      commit("setConfirmedData", status);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async storeOrderResetConfirmation({ commit, state, rootState }, status) {
    try {
      const orderState = await Order.setOrderState(rootState.config, state.order, rootState.config.api.states.new);
      commit("setOrderState", orderState.state);
      commit("resetConfirmedData", status);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async storeOrderCompleted({ commit, state, rootState }) {
    try {
      const orderState = await Order.setOrderState(
        rootState.config,
        state.order,
        rootState.config.api.states.completed
      );
      commit("setOrderState", orderState.state);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async storeOrderPaymentStart({ state, rootState }) {
    try {
      const orderState = await Order.setOrderState(
        rootState.config,
        state.order,
        rootState.config.api.states.payment_start
      );
      document.location = orderState.payment_url;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  setActiveLaboratory({ commit }, payload) {
    commit("setActiveLaboratory", payload);
  },
  getNextActiveRegistration({ commit, state, dispatch }, id) {
    commit("setNextActiveRegistration", id);
    if (state.activeRegistrationIndex !== null && state.activeRegistrationIndex < state.registrations.length)
      commit("setSessions", state.registrations[state.activeRegistrationIndex].linked_event.sessions);
    else {
      dispatch("storeOrderCompleted");
    }
  },
  async storeRegistrationLabs({ rootState, state, getters }) {
    const labs = mapLabsForAPI(state.selectedLabs);
    try {
      await Order.setRegistrationLaboratories(rootState.config, getters.activeRegistration(state), labs);
      state.voidLabsChecked = false;
      return true;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async storeAndSuccessRegistrationLabs({ commit, dispatch, rootState }) {
    try {
      const status = await dispatch("storeRegistrationLabs");
      if (status) commit("setLabSavedMessage", "Laboratori modificati correttamente");
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async storeAndSlideRegistrationLabs({ state, dispatch, rootState }) {
    try {
      const status = await dispatch("storeRegistrationLabs");
      if (status) dispatch("getNextActiveRegistration", state.activeRegistrationIndex);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  getNextLegSelectRegistration({ commit, state, dispatch }, id) {
    commit("setNextLegSelectRegistration", id);
    if (state.legSelectRegistrationIndex !== null && state.legSelectRegistrationIndex < state.registrations.length) {
      dispatch("checkOneLegBundle");
    } else if (state.selectedLegs.length > 0) {
      dispatch("storeSelectedLegs", state.selectedLegs);
    }
  },
  async checkOneLegBundle({ commit, state, dispatch, getters }) {
    const legSelectRegistration = getters.legSelectRegistration();
    const bundleEvent = legSelectRegistration.linked_event;
    if (bundleEvent.bundle_items[state.bundleItemIndex].legs.length === 1) {
      commit("setSelectedLeg", bundleEvent.bundle_items[state.bundleItemIndex].legs[0]);
      dispatch("storeAndSlideSelectedLeg");
    }
  },
  async storeSelectedLegs({ commit, rootState, state }, payload) {
    try {
      const orderItems = payload.map(leg => {
        return {
          event: leg.event.id,
          event_leg: leg.event_leg.id,
          bundle_parent: leg.bundle.id,
        };
      });

      const order = await Order.addItemsToOrder(rootState.config, state.order, orderItems);
      commit("setOrder", order);
      commit("setRegistrations", order.registrations);
      return true;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async storeSelectedLeg({ rootState, state }, payload) {
    try {
      const orderItem = {
        event: payload.event.id,
        event_leg: payload.event_leg.id,
        bundle_parent: payload.bundle.id,
      };
      await Order.addItemToOrder(rootState.config, state.order, orderItem);
      return true;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async storeAndSlideSelectedLeg({ rootState, state, dispatch, commit, getters }) {
    try {
      const legSelectRegistration = getters.legSelectRegistration();
      const bundleEvent = legSelectRegistration.linked_event;
      const bundleItem = getters.bundleItem;
      commit("addSelectedLeg", {
        bundle: legSelectRegistration,
        event: bundleItem,
        event_leg: state.selectedLeg,
      });
      if (state.bundleItemIndex < bundleEvent.bundle_items.length - 1) {
        let found = false;
        for (let i = state.bundleItemIndex + 1; i < bundleEvent.bundle_items.length; i++) {
          if (bundleEvent.bundle_items[i].legs.length === 1) {
            commit("addSelectedLeg", {
              bundle: legSelectRegistration,
              event: bundleEvent.bundle_items[i],
              event_leg: bundleEvent.bundle_items[i].legs[0],
            });
          } else if (bundleEvent.bundle_items[i].legs.length > 1) {
            commit("setBundleItemIndex", i);
            found = true;
          }
        }
        if (!found) {
          dispatch("getNextLegSelectRegistration", state.legSelectRegistrationIndex);
        }
      } else {
        dispatch("getNextLegSelectRegistration", state.legSelectRegistrationIndex);
      }
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  setEmptyLabs({ getters, commit }, status) {
    let sessions = getters.sessions();
    for (let session of sessions) {
      if (status) {
        for (let lab of session.labs) {
          if (lab.empty) {
            commit("setActiveLaboratory", { session: session.id, lab: lab });
          }
        }
      } else {
        commit("setActiveLaboratory", { session: session.id, lab: null });
      }
    }
  },
  async removeItem({ commit, rootState }, registration_id) {
    try {
      const order = await Order.deleteRegistration(rootState.config, registration_id);
      commit("setOrder", order);
      return order;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.setup(ModalAlert, "", e.response.data.error, e.response.data.codes);
    }
  },
  goToCheckout({ state }, payload) {
    VueCookies.set("formazioneReturnUrl", document.location, "0", "/", ".deascuola.it");
    if (payload && typeof payload === "number") document.location = `/registration.html?order_id=${payload}`;
    else document.location = `/registration.html?order_id=${state.order.id}`;
  },
};

const mutations = {
  setOrders: (oldState, orders) => (oldState.orders = orders),
  setOrdersLoaded: oldState => (oldState.ordersLoaded = true),
  setRegistrations: (oldState, registrations) => (oldState.registrations = registrations),
  replaceRegistration: (oldState, registration) => {
    Vue.set(oldState.registrations, oldState.activeRegistrationIndex, registration);
  },
  generalErrorMessage: (oldState, message) => (oldState.generalErrorMessage = message),
  setLabSavedMessage: (oldState, message) => (oldState.labSavedMessage = message),
  setOrderState: (oldState, state) => (oldState.order.state = state),
  setActiveRegistrationIndex: (oldState, index) => (oldState.activeRegistrationIndex = index),
  setLegSelectRegistrationIndex: (oldState, index) => (oldState.legSelectRegistrationIndex = index),
  setBundleItemIndex: (oldState, index) => {
    oldState.selectedLeg = {};
    oldState.bundleItemIndex = index;
  },
  setSelectedLeg: (oldState, leg) => (oldState.selectedLeg = leg),
  addSelectedLeg: (oldState, orderItem) => oldState.selectedLegs.push(orderItem),
  setEmptySessions: oldState => {
    setFirstEmptySession(oldState);
  },
  setMapSelectedLabs: oldState => {
    mapSelectedLabs(oldState);
  },
  setSessions: (oldState, sessions) => (oldState.registrations[oldState.activeRegistrationIndex].sessions = sessions),
  setActiveLaboratory: (oldState, payload) => {
    const event = oldState.registrations[oldState.activeRegistrationIndex].linked_event;
    // scanning through the session to pick the right session (by id)
    // and replacing its selected lab. as registrations and sessions are arrays we
    // don't need anything special for reactive behavior
    // FIXME: This looks convoluted and I think there are better ways to do the same
    for (let id in event.sessions) {
      if (event.sessions[id].id === payload.session) {
        event.sessions[id].selected_lab = payload.lab;
        event.sessions[id].isOpen = payload.lab ? false : true;
        if (payload.lab) {
          oldState.voidLabsChecked = false;
        }
      }
    }
    setFirstEmptySession(oldState);
    mapSelectedLabs(oldState);
  },
  setNextActiveRegistration: (oldState, id) => {
    // we set activeRegistrationIndex for selecting the card in the sidebar and some shortcuts in this
    if (id === null) return;
    for (let index in oldState.registrations) {
      oldState.registrations[index].active = false;
    }
    let index = id;
    let isFound = false;
    do {
      index++;
      if (
        index < oldState.registrations.length &&
        oldState.registrations[index].linked_event.sessions &&
        oldState.registrations[index].linked_event.sessions.length
      ) {
        oldState.registrations[index] = { ...oldState.registrations[index], active: true };
        oldState.activeRegistrationIndex = index;
        isFound = true;
      }
    } while (index < oldState.registrations.length && !isFound);

    if (!isFound) {
      oldState.activeRegistrationIndex = null;
    }

    setFirstEmptySession(oldState);
    mapSelectedLabs(oldState);
  },
  setNextLegSelectRegistration: (oldState, id) => {
    // we set legSelectRegistrationIndex for selecting the card in the sidebar and some shortcuts in this
    if (id === null) return;
    for (let index in oldState.registrations) {
      oldState.registrations[index].legSelected = false;
    }
    let index = id;
    let isFound = false;
    do {
      index++;
      if (
        index < oldState.registrations.length &&
        oldState.registrations[index].linked_event.bundle_items &&
        oldState.registrations[index].linked_event.bundle_items.length
      ) {
        oldState.registrations[index] = { ...oldState.registrations[index], legSelected: true };
        oldState.legSelectRegistrationIndex = index;
        oldState.bundleItemIndex = 0;
        isFound = true;
      }
    } while (index < oldState.registrations.length && !isFound);

    if (!isFound) {
      oldState.legSelectRegistrationIndex = null;
    }
  },
  setOrder: (oldState, order) => {
    oldState.order = order;
  },
  setVoidLabsChecked: (oldState, status) => {
    oldState.voidLabsChecked = status;
  },
};

const setFirstEmptySession = oldState => {
  // we have to detect which is the first empty session and extract its id
  // this will end up setting defaultOpen prop on LabSession component
  // FIXME: This looks convoluted and I think there are better ways to do the same
  const emptySessions = getters
    .sessions(oldState)()
    .filter(session => !session.selected_lab);
  if (emptySessions.length > 0) oldState.firstEmptySession = emptySessions.shift().id;
  else oldState.firstEmptySession = null;
};

const mapSelectedLabs = oldState => {
  // mapping the selected labs in an easier to search object to detect if a lab has been already selected
  // elsewhere
  // FIXME: This looks convoluted and I think there are better ways to do the same
  const filledSections = getters
    .sessions(oldState)()
    .filter(session => session.selected_lab);

  oldState.selectedLabs = getObjectFromEntries(filledSections);
};

const mapLabsForAPI = selectedLabs => {
  return Object.keys(selectedLabs).map(key => {
    return {
      session: key,
      laboratory: selectedLabs[key],
    };
  });
};

function getObjectFromEntries(entries) {
  let tempObject = {};
  entries.forEach(item => {
    tempObject[item.id] = item.selected_lab.id;
  });
  return tempObject;
}
export default {
  state,
  getters,
  actions,
  mutations,
};
